/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAzureCsp extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForAzureCsp");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForAzureCsp.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAzureCsp>): CostProcessingMemoryForAzureCsp {
        let obj = Object.assign(new CostProcessingMemoryForAzureCsp(), model);
        CostProcessingMemoryForAzureCsp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAzureCsp>): CostProcessingMemoryForAzureCsp {
        if (!model) return null;
        return CostProcessingMemoryForAzureCsp.newInstance(<CostProcessingMemoryForAzureCsp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAzureCsp) {
        if (!obj) return;

        models.CostProcessingMemoryForAzureCsp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAzureCsp): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAzureCsp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.CostProcessingPeriodMemoryForAzureCsp.fixupPrototype(val);
            }
        }
    }

    /**
     * Processed billing periods
     */
    periods: Array<models.CostProcessingPeriodMemoryForAzureCsp>;

}
